import Vue from 'vue'
import Router from 'vue-router'

const Login = () => import('@/pages/login/login');
const InternalLogin = () => import('@/pages/login/InternalLogin');
const Home = () => import('@/pages/home/home');
const Default = () => import('@/pages/default/default');
const Rightls = () => import('@/pages/rightls/rightls');
const YDV = () => import('@/pages/ydv/ydv');
const MessageDetalis = () => import('@/pages/Message/MessageDetalis');
const AddnewRepair = () => import('@/pages/home/components/addnewRepair');
const NoticeList = () => import('@/pages/notice/noticelist');
const NoticeDetail = () => import('@/pages/notice/components/noticedetail');
const StoreWarn = () => import('@/pages/storewarn/storewarn');
const wxAuthorization = () => import('@/pages/wxauthorization/wxauthorization');
const wxauthorization2 = () => import('@/pages/wxauthorization/wxauthorization2');
const Client = () => import('@/pages/client/client');
const ProductDetail = () => import('@/pages/product/productdetail');

const RegisterUser = () => import('@/pages/login/registeruser');
const OrderList = () => import('@/pages/product/orderlist');
const OpenDevelopment = () => import('@/pages/opendevelopment/opendevelopment');
const OrderBuy = () => import('@/pages/product/orderbuy');
const MonitorList = () => import('@/pages/product/monitorlist');
const outlist = () => import('@/pages/ydv/outlist');
const UserList = () => import('@/pages/userset/UserList');
const trilateralconfig = () => import('@/pages/trilateralconfig/trilateralconfig');
const trilateralstoreconfig = () => import('@/pages/trilateralconfig/trilateralstoreconfig');
const storelist = () => import('@/pages/store/storelist');
Vue.use(Router)

const mainRoutes = [
  {
    path: '/storelist',
    name: 'storelist',
    component: storelist,
    meta: {
      title: '机构列表',

    },
  },
  {
    path: '/InternalLogin/:UserId',
    name: 'InternalLogin',
    component: InternalLogin,
    meta: {
      title: '内部登录',
      noBar: true
    },
  },
  {
    path: '/trilateralstoreconfig',
    name: 'trilateralstoreconfig',
    component: trilateralstoreconfig,
    meta: {
      title: '数据上报设置',

    },
  },
  {
    path: '/trilateralconfig',
    name: 'trilateralconfig',
    component: trilateralconfig,
    meta: {
      title: '数据上报设置',

    },
  },
  {
    path: '/MessageDetalis',
    name: 'MessageDetalis',
    component: MessageDetalis,
    meta: {
      title: '报警设置',

    },
  },
  {
    path: '/',
    name: 'login',
    component: Login,
    meta: {
      title: '登陆',
      noBar: true

    },
  }, {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      title: '首页',

    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: '登陆',
      noBar: true
    },

  },
  {
    path: '/default/:areaid/:areaname',
    name: 'default',
    component: Default,
    meta: {
      title: '默认页',
      noBar: false
    },
  }, {
    path: '/rightls/:StoreID/:AreaID/:Status/:StoreType',
    name: 'rightls',
    component: Rightls,
    meta: {
      title: '设备列表',
      noBar: false
    },
  }, {
    path: '/ydv',
    name: 'ydv',
    component: YDV,
    meta: {
      title: '设备详情',
      noBar: false
    },
  },
  {
    path: '/outlist',
    name: 'outlist',
    component: outlist,
    meta: {
      title: '超标记录',
      noBar: false
    },
  }, {
    path: '/addnewRepair',
    name: 'addnewRepair',
    component: AddnewRepair,
    meta: {
      title: '报修',
      noBar: false
    },
  }, {
    path: '/noticelist',
    name: 'noticelist',
    component: NoticeList,
    meta: {
      title: '系统公告',
      noBar: false
    },
  }, {
    path: '/noticedetail',
    name: 'noticedetail',
    component: NoticeDetail,
    meta: {
      title: '公告详情',
      noBar: false
    },
  },
  {
    path: '/storewarn/:areaid',
    name: 'storewarn',
    component: StoreWarn,
    meta: {
      title: '整改企业',
      noBar: false
    },
  },
  {
    path: '/wxauthorization',
    name: 'wxauthorization',
    component: wxAuthorization,
    meta: {
      title: '微信授权',
      noBar: false
    },
  },
  {
    path: '/wxauthorization2',
    name: 'wxauthorization2',
    component: wxauthorization2,
    meta: {
      title: '重要通知',
      noBar: false
    },
  },
  {
    path: '/client/:storetype/:areaid',
    name: 'client',
    component: Client,
    meta: {
      title: '企业列表',
      noBar: false
    },
  },
]
const secondRouters = [
  {
    path: '/userlist',
    name: 'userlist',
    component: UserList,
    meta: {
      title: '用户列表',
    },
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterUser,
    meta: {
      title: '注册',
      noBar: true
    },
  },
  {
    path: '/product',
    name: 'product',
    component: ProductDetail,
    meta: {
      title: '商品详情',
      noBar: true
    },
  },
  {
    path: '/orderlist',
    name: 'orderlist',
    component: OrderList,
    meta: {
      title: '订单列表',
      noBar: false
    },
  },
  {
    path: '/opendevelopment',
    name: 'opendevelopment',
    component: OpenDevelopment,
    meta: {
      title: '第三方应用开发',
      noBar: false
    },
  },
  {
    path: '/orderbuy',
    name: 'orderbuy',
    component: OrderBuy,
    meta: {
      title: '服务购买',
      noBar: false
    },
  },
  {
    path: '/monitorlist',
    name: 'monitorlist',
    component: MonitorList,
    meta: {
      title: '设备列表',
      noBar: false
    },
  },
]

const appRouter = [...mainRoutes, ...secondRouters];
export default new Router({
  routes: appRouter,
});



// WEBPACK FOOTER //
// ./src/router/index.js